const yup = require("yup");

// Routing number checksum validation
const routingNumberChecksum = (value) => {
  if (!/^\d{9}$/.test(value)) return false;
  const digits = value.split("").map(Number);
  const checksum =
    3 * (digits[0] + digits[3] + digits[6]) +
    7 * (digits[1] + digits[4] + digits[7]) +
    (digits[2] + digits[5] + digits[8]);
  return checksum % 10 === 0;
};

const paymentDetailsSchema = yup.object().shape({
  accountNumber: yup.string().optional(),
  routingNumber: yup.string().optional().nullable(),
  accountName: yup.string().optional().nullable(),
});

const requiredPaymentDetailsSchema = paymentDetailsSchema.shape({
  accountName: yup.string().required("Account name is required"),
  accountNumber: yup
    .string()
    .matches(/^\d{6,17}$/, "Account number must be 6-17 digits")
    .required("Account number is required"),
  routingNumber: yup
    .string()
    .required("Routing number is required")
    .test(
      "routing-number-checksum",
      "Routing number is invalid",
      (val) => !!val && routingNumberChecksum(val),
    ),
});

module.exports = {
  paymentDetailsSchema,
  requiredPaymentDetailsSchema,
};
